import React from 'react'

const InstantMaturityAssessments = () => {
  const NavigateToWorkflow = () => {
    // Open URL in a new tab when the button is clicked
    window.open(
      'https://demoserver.botgo.io/bromho-assessments/assessment',
      '_blank',
      'noopener,noreferrer'
    )
  }
  // testing/
  return (
    <div
      className='card m-1 text-decoration-none align-items-center text-center'
      style={{
        width: '20rem',
        overflow: 'hidden',
        boxShadow: 'rgb(204, 204, 204) 2px 2px 9px',
        transform: 'scale(1)'
      }}
    >
      <img
        className=' mt-4 w-100px h-100px'
        src='https://www.striata.com/wp-content/uploads/2020/06/Digital-Maturity-Benchmark-Study-Ranks-Grocerys-Top-Retailers.png'
        alt='Assessment logo'
      />
      <div className='card-body align-items-center text-center'>
        <h5 className='card-title text-dark'>Instant Maturity Assessments</h5>
        <p className='card-text text-muted'>
          Benchmark yourself in 2 minutes-get an AI-generated board-ready report.
        </p>
        <button className='btn btn-primary' onClick={NavigateToWorkflow}>
          Start
        </button>
      </div>
    </div>
  )
}
export default InstantMaturityAssessments
